import {Record, Map} from 'immutable';
import {FileRecord} from '@packages/systems/core/records/FileRecord';
import type {RawFileType} from '@packages/systems/core/records/FileRecord';

type RawImageRefType = {
  alt: string | null;
  fileId: string;
  file: RawFileType;
  fileSize: number;
  url: string;
};

export type ImageRefRecordProps = {
  alt: string | null;
  fileId: string;
  file: FileRecord | null;
  fileSize: number;
  url: string;
  tmp: ImageRefType | null;
};

const defaultValues: ImageRefRecordProps = {
  alt: null,
  fileId: '',
  file: null,
  fileSize: 0,
  url: '',
  tmp: null,
};

const Parent: Record.Factory<ImageRefRecordProps> = Record(
  defaultValues,
  'ImageRefRecord'
);

export class ImageRefRecord extends Parent {
  declare alt: ImageRefRecordProps['alt'];
  declare fileId: ImageRefRecordProps['fileId'];
  declare file: ImageRefRecordProps['file'];
  declare fileSize: ImageRefRecordProps['fileSize'];
  declare url: ImageRefRecordProps['url'];
  declare tmp: ImageRefRecordProps['tmp'];

  static reify(json: RawImageRefType) {
    const {alt, fileId, file, fileSize, url} = json;

    return new ImageRefRecord({
      alt,
      fileId,
      file: FileRecord.reify(file),
      fileSize,
      url,
    });
  }
  toJSON() {
    return Map(this).remove('tmp').toJSON();
  }
}

// ImageRefRecord is a Record subclass so we
// use the nominal type of the subclass.
export type ImageRefType = ImageRefRecord;
